<template>
  <div>
    한글 내용
  </div>
</template>

<script>
import App from './app.js'; export default Object.assign({}, App);
</script>